import audi from './audi'

const Theme = {
   'localhost': audi,
   'audi.smartintel.io': audi
}

export default Theme


// WEBPACK FOOTER //
// ./src/constants/theme/index.js